import { composeMoney } from '@pbk/utils';
export const composeMoneyWithoutFractionDigits = (amount, currency = 'CZK') => {
    return composeMoney({
        money: { amount, currency },
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
